/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'links': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<path pid="0" _fill="#848484" fill-rule="evenodd" d="M6.12 3.896a.697.697 0 0 1 .984 0 2.62 2.62 0 0 1 .774 1.867c0 .706-.275 1.368-.774 1.867l-2.598 2.598A2.632 2.632 0 0 1 2.639 11a2.628 2.628 0 0 1-1.867-.772 2.641 2.641 0 0 1 0-3.733l.636-.636a.698.698 0 0 1 .985 0 .7.7 0 0 1 0 .985l-.636.635a1.249 1.249 0 0 0 1.765 1.765L6.12 6.646a1.247 1.247 0 0 0 0-1.765.696.696 0 0 1 0-.984zM10.228.772a2.645 2.645 0 0 1 0 3.735l-.635.636a.697.697 0 0 1-.984-.985l.635-.635a1.25 1.25 0 0 0 0-1.766c-.471-.47-1.293-.47-1.764 0l-2.6 2.599a1.243 1.243 0 0 0-.365.883c0 .333.13.645.366.882a.696.696 0 1 1-.985.984 2.622 2.622 0 0 1-.774-1.867c0-.705.275-1.369.775-1.868L6.494.772a2.642 2.642 0 0 1 3.734 0z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/compiled-icons/links.js